import styled from "styled-components";
import { useTranslation } from "react-i18next";
import Button from "../Button/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useAccount } from "src/context/account/account.provider";
import ResponsiveImage from "../ImageWrapper/ResponsiveImage";
import useResponsiveImageUrl from "../../utils/useResponsiveImageUrl";
import Cookies from "js-cookie";

const Hero = () => {
  const { t } = useTranslation();
  const accessToken = Cookies.get("access_token");
  const downloadBgImage = useResponsiveImageUrl("rewards/pg-app-image-parralax.jpg");

  return (
    <>
      <HeroContainer>
        <container-div>
          <Row>
            <Col className="text-col" lg={5}>
              <h1>{t("rewards.section-1-title")}</h1>
              <p>{t("rewards.section-1-text")}</p>
              <Button
                bgColor="var(--red)"
                color="var(--white)"
                hoverBgColor="var(--black)"
                hoverColor="var(--white)"
                href={
                  accessToken ? t("routes.myAccount") : t("routes.register")
                }
                label={
                  accessToken
                    ? t("footer.myAccount")
                    : t("rewards.section-1-btn")
                }
                width="wide"
                size="large"
              />
            </Col>
            <Col lg={7}>
              <ResponsiveImage
                src={"home/rewards_cards.jpg"}
                alt="rewards-card"
              />
            </Col>
          </Row>
        </container-div>
      </HeroContainer>
      <DownloadSection bgImage={downloadBgImage}>
        <container-div>
          <DownloadContent>
            <DownloadText>{t("rewards.section-1-download-text")}</DownloadText>
            <ButtonGroup>
              <AppStoreLink
                href={t("downloadAndWin2026.hero.appStoreUrl")}
                target="_blank"
                rel="noopener noreferrer"
              >
                <ResponsiveImage
                  src="promotions/download-and-win-2026/app-store.png"
                  alt="Download on the App Store"
                />
              </AppStoreLink>
              <AppStoreLink
                href={t("downloadAndWin2026.hero.googlePlayUrl")}
                target="_blank"
                rel="noopener noreferrer"
              >
                <ResponsiveImage
                  src="promotions/download-and-win-2026/google-play.png"
                  alt="Get it on Google Play"
                />
              </AppStoreLink>
            </ButtonGroup>
          </DownloadContent>
        </container-div>
      </DownloadSection>
    </>
  );
};

const HeroContainer = styled.div`
  width: 100%;
  background-color: var(--lightgrey);
  padding-top: 140px;
  padding-bottom: 50px;
  text-align: center;
  @media (min-width: 991px) {
    padding-top: 150px;
    text-align: left;
    a {
      margin-left: 0;
    }
  }
  .text-col {
    display: flex;
    flex-direction: column;
    justify-content: center;
    h1 {
      font-size: 65px;
      font-weight: 900;
      margin: 0 0 1rem;
    }
    p {
      font-size: 22px;
    }
  }
  img {
    max-width: 100%;
    margin-top: 1rem;
    @media (min-width: 576px) {
      max-width: 90%;
    }
    @media (min-width: 991px) {
      max-width: 100%;
    }
  }
  @media (max-width: 768px) {
    .text-col {
      h1 {
        font-size: 32px;
      }
    }
  }
`;

const DownloadSection = styled.div`
  width: 100%;
  background: url(${(props) => props.bgImage}) center center / cover no-repeat;
  padding: 20px 0;
  position: relative;

  container-div {
    position: relative;
    z-index: 2;
  }
`;

const DownloadContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;

  @media (min-width: 991px) {
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 3rem;
  }
`;

const DownloadText = styled.h2`
  font-weight: 900;
  margin: 0 0 1rem;
  color: var(--white);
  text-align: center;
  font-size: 1.5rem;

  @media (min-width: 991px) {
    margin: 0;
    font-size: 2rem;
    white-space: nowrap;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  justify-content: center;

  a {
    padding: 0;
    border-radius: 8px;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent !important;
    border: none !important;
    overflow: visible;

    &:hover {
      opacity: 0.8;
      background: transparent !important;
    }

    img,
    svg,
    picture img {
      height: 50px;
      width: auto;
      display: block;
      max-width: none;
    }

    picture {
      display: flex;
      height: 50px;
    }
  }
`;

const AppStoreLink = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border-radius: 8px;
  transition: opacity 0.3s ease;
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }

  img {
    height: 50px;
    width: auto;
  }
`;

export default Hero;
